// extracted by mini-css-extract-plugin
export var actionButton = "_ka-0";
export var fileInput = "_ka-2";
export var paperclip = "_ka-1";